import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { always, empty } from 'ramda';
import { clearHash, getLocationHash, updateHash } from '../../utils/location';

export class HashRoute extends PureComponent {
  static propTypes = {
    hashName: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
  };

  static defaultProps = {
    onEnter: empty,
    onLeave: empty,
  };

  state = {
    activeLocationHash: getLocationHash(),
  };

  componentDidMount() {
    window.addEventListener('hashchange', this.handleHashChange, false);

    if (this.props.isActive) {
      this.enterRoute();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isActive && this.props.isActive) {
      this.enterRoute();
    }

    if (prevProps.isActive && !this.props.isActive) {
      this.leaveRoute();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange, false);
  }

  enterRoute = () => {
    this.setState({ activeLocationHash: this.props.hashName }, () => {
      if (!this.isRouteHash(getLocationHash())) {
        updateHash(this.props.hashName);
      }
    });
  };

  isRouteHash = hash => hash === this.props.hashName;

  leaveRoute = () => {
    this.setState({ activeLocationHash: '' }, () => {
      clearHash(location.pathname);
    });
  };

  handleHashChange = () => {
    const prevHash = this.state.activeLocationHash;
    const newHash = getLocationHash();

    if (prevHash === newHash) {
      return;
    }

    this.setState({ activeLocationHash: newHash });

    if (!this.isRouteHash(prevHash) && this.isRouteHash(newHash)) {
      this.enterRoute();
      this.props.onEnter();
    } else if (this.isRouteHash(prevHash) && !this.isRouteHash(newHash)) {
      this.leaveRoute();
      this.props.onLeave();
    }
  };

  render = always(null);
}
